import { PatientProfileCheckKinds } from "../../../../../../../documaker/domain/format/objects";
import { IntegerTranslator } from "../../values";

export class PatientProfileCheckKindTranslator {
  from(bean: string): PatientProfileCheckKinds {
    const result = this.integer.from(bean);
    return result
      ? result
      : PatientProfileCheckKinds.None;  // checkは古い版ではundefinedもあるのでNone扱いにする.
  }

  to(object: PatientProfileCheckKinds) {
    return this.integer.to(object);
  }
 
  private readonly integer = new IntegerTranslator();
}
